import { render, staticRenderFns } from "./PessoaFisica.vue?vue&type=template&id=31e92c4d"
import script from "./PessoaFisica.vue?vue&type=script&lang=js"
export * from "./PessoaFisica.vue?vue&type=script&lang=js"
import style0 from "./PessoaFisica.vue?vue&type=style&index=0&id=31e92c4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports